module.exports = __webpack_public_path__ + "static/media/retirement-object-1-1-2.ae7b3486.svg";